import React, {SVGProps} from "react";

const IconHamburger = (props: SVGProps<SVGSVGElement>) => {
    const {color = "#404446", width = "24", height = "25", ...rest} = props;
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 24 25"
            fill="none"
            {...rest}
        >
            <path
                d="M18.248 6.73081H5.66623C5.4679 6.73081 5.2777 6.65202 5.13746 6.51178C4.99723 6.37155 4.91844 6.18134 4.91844 5.98302C4.91844 5.78469 4.99723 5.59449 5.13746 5.45425C5.2777 5.31401 5.4679 5.23523 5.66623 5.23523H18.248C18.4463 5.23523 18.6365 5.31401 18.7768 5.45425C18.917 5.59449 18.9958 5.78469 18.9958 5.98302C18.9958 6.18134 18.917 6.37155 18.7768 6.51178C18.6365 6.65202 18.4463 6.73081 18.248 6.73081V6.73081Z"
                fill={color}
            />
            <path
                d="M20.1604 12.7699H3.73894C3.54061 12.7699 3.35041 12.6911 3.21017 12.5509C3.06993 12.4107 2.99115 12.2205 2.99115 12.0221C2.99115 11.8238 3.06993 11.6336 3.21017 11.4934C3.35041 11.3531 3.54061 11.2744 3.73894 11.2744H20.1604C20.3587 11.2744 20.5489 11.3531 20.6891 11.4934C20.8294 11.6336 20.9081 11.8238 20.9081 12.0221C20.9081 12.2205 20.8294 12.4107 20.6891 12.5509C20.5489 12.6911 20.3587 12.7699 20.1604 12.7699V12.7699Z"
                fill={color}
            />
            <path
                d="M18.248 18.8081H5.66623C5.4679 18.8081 5.2777 18.7293 5.13746 18.5891C4.99723 18.4488 4.91844 18.2586 4.91844 18.0603C4.91844 17.862 4.99723 17.6718 5.13746 17.5315C5.2777 17.3913 5.4679 17.3125 5.66623 17.3125H18.248C18.4463 17.3125 18.6365 17.3913 18.7768 17.5315C18.917 17.6718 18.9958 17.862 18.9958 18.0603C18.9958 18.2586 18.917 18.4488 18.7768 18.5891C18.6365 18.7293 18.4463 18.8081 18.248 18.8081Z"
                fill={color}
            />
        </svg>
    );
};

export default IconHamburger;
